@if (loading.isLoading()) {
  <div class="top-loading-bar fixed top-0 left-0 right-0 z-[1000] h-[3px] overflow-hidden bg-primary/15" role="progressbar" aria-label="Loading"></div>
}
<p-toast position="top-right" />
<p-confirmdialog />
<router-outlet />
